export default {
      id: "ic-telephone-usage",
      viewBox: "0 0 18 18",
      url: "../dist/images/" + "sprite.svg#ic-telephone-usage",
      toString: function () {
        return this.url;
      }
    }